import classNames from 'classnames'
import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'
import { FormItem } from 'components'
import { countries } from 'i18n-iso-countries/langs/de.json'
import messages from 'i18n/messages'
import flowRight from 'lodash/flowRight'
import { makeSelectDateById } from 'logic/dates'
import { disableCustomerDeliveryAddr, enableCustomerDeliveryAddr, makeSelectCustomer, updateCustomerAddrIndexAttr, updateCustomerAttr, setCustomerFromLS } from 'logic/customers'
import { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import Select from 'react-select'
import { Col, FormGroup, FormText, Input, Label, Row } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'

class AdditionalFields extends Component {

  static propTypes = {
    isVoucher: PropTypes.bool,
    org: PropTypes.object.isRequired,
  }

  static defaultProps = {
    isVoucher: false
  }

  handleChange = (key, value) =>
    this.props.actions.updateCustomerAttr(
      key,
      value,
    )

  handleToggleEmailMarketing = () =>
    this.props.actions.updateCustomerAttr(
      'email_marketing',
      !this.props.customer.email_marketing,
    )

  handleToggleCoronaSubscription = () =>
    this.props.actions.updateCustomerAttr(
      'subscribe_corona',
      !this.props.customer.subscribe_corona,
    )

  render() {
    const { customer, org, collapsed } = this.props

    return (
      <div className={classNames('contact-form hidden-on-collapsed additional-fields tt-checkout', { collapsed })}>
        <div className="section-header">
        </div>
        <div className="collapsed-content">
          {org.portal.subscribe_newsletter_checkbox && !isEmpty(org.portal.subscribe_newsletter_text)
            ? <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={customer.email_marketing || false}
                    onChange={this.handleToggleEmailMarketing}
                  />
                  <span className="form-check-sign" />
                  <span>
                    <span dangerouslySetInnerHTML={{ __html: org.portal.subscribe_newsletter_text }} />
                  </span>
                </Label>
              </FormGroup>
            : null
          }
          {org.portal.subscribe_corona_checkbox
            ? <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={customer.subscribe_corona || false}
                    onChange={this.handleToggleCoronaSubscription}
                  />
                  <span className="form-check-sign" />
                  <FormattedMessage {...messages.subscribeCorona} />
                  <span className="ml-1" />
                  <FormattedMessage {...messages.optionalBrackets} />
                </Label>
              </FormGroup>
            : null
          }
        </div>
      </div>
    )
  }

}

const mapStateToProps = createStructuredSelector({
  customer: makeSelectCustomer(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateCustomerAttr,
  }, dispatch)
})

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(AdditionalFields)
